import React, { useEffect, useState } from "react";

const ComingSoon = () => {
  const [fadeIn, setFadeIn] = useState(false);
  const [textIndex, setTextIndex] = useState(0);
  const slogan = " Dreaming, Innovating and Inspiring "; // Slogan text

  // Simulate typing effect for slogan
  useEffect(() => {
    if (textIndex < slogan.length) {
      setTimeout(() => {
        setTextIndex(textIndex + 1);
      }, 100);
    }
  }, [textIndex]);

  // Adding a delay before showing the content for the fade-in effect
  useEffect(() => {
    setTimeout(() => {
      setFadeIn(true);
    }, 500);
  }, []);

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-r from-[#0076FF] via-[#009FFF] to-[#0087BD] relative">
      {/* Overlay and Container */}
      <div className="w-full h-full bg-black bg-opacity-40 absolute top-0 left-0"></div>
      <div className="z-10 flex flex-col justify-center items-center text-center p-6 space-y-8 max-w-4xl">
        {/* Coming Soon Section */}
        <div className="space-y-6">
          <h2 className="text-4xl md:text-6xl lg:text-8xl font-bold text-white">
            Coming Soon
          </h2>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white animate-pulse tracking-wide">
            LaunchForward
          </h1>
          <p className="text-lg md:text-2xl text-white tracking-wide font-bold max-w-md mx-auto">
            {slogan.substring(0, textIndex)}
            {textIndex === slogan.length ? (
              ""
            ) : (
              <span className="blink">|</span>
            )}
          </p>
        </div>

        {/* Additional Content */}
        <div
          className={`transition-opacity duration-1000 space-y-4 ${
            fadeIn ? "opacity-100" : "opacity-0"
          }`}
        >
          <p className="text-base md:text-lg text-white max-w-md mx-auto">
            We’re working on something amazing. Stay tuned!
          </p>

          {/* Contact Email Display */}
          <div className="mt-10">
            <p className="text-base md:text-lg text-white">
              For inquiries, contact us at:{" "}
              <a
                href="mailto:info@launchforward.org"
                className="underline hover:text-pink-200 transition"
              >
                inquires@launchforward.org
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
